class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
    this.facetMobileTrigger = document.querySelector('#facetsTrigger .label');
    if (this.facetMobileTrigger) this.facetMobileTrigger.addEventListener('click', this.facetMobileShow);
    this.facetMobileClose = document.querySelector('#facetsClose .icon');
    if (this.facetMobileClose) this.facetMobileClose.addEventListener('click', this.facetMobileCloseMenu);
    this.facetMobileSee = document.querySelector('#facetsSee');
    if (this.facetMobileSee) this.facetMobileSee.addEventListener('click', this.facetMobileCloseMenu);
    FacetFiltersForm.renderProductCount();
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    // const countContainer = document.getElementById('ProductCount');
    // const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.product-grid').classList.add('loading');
    // if (countContainer){
    //   countContainer.classList.add('loading');
    // }
    // if (countContainerDesktop){
    //   countContainerDesktop.classList.add('loading');
    // }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount();
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount();
  }

  static renderProductGridContainer(html) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html')
    document.getElementById('ProductGridContainer').dataset.productCount = parsedHTML.getElementById('ProductGridContainer').dataset.productCount
    document.querySelector('#ProductGridContainer #product-grid').innerHTML = parsedHTML.querySelector('#ProductGridContainer #product-grid').innerHTML;
    // document.querySelector('#ProductGridContainer .pagination__list').innerHTML = parsedHTML.querySelector('#ProductGridContainer .pagination__list').innerHTML;
    document.querySelectorAll('load-more').forEach(loadmore => {
      if (!parsedHTML.querySelector(`load-more#${loadmore.id}`)) {
        loadmore.remove();
        return;
      }
      loadmore.setAttribute("data-url", parsedHTML.querySelector(`load-more#${loadmore.id}`)?.dataset.url);
    });
    if(parsedHTML.querySelector('#ProductGridContainer .pagination__list') && document.querySelector('#ProductGridContainer .pagination__list')) {
      document.querySelector('#ProductGridContainer .pagination__list').innerHTML = parsedHTML.querySelector('#ProductGridContainer .pagination__list').innerHTML;
    }
    document.getElementById('ProductGridContainer').querySelector('.product-grid').classList.remove('loading');
  }

  static renderProductCount() {
    const count = document.getElementById('ProductGridContainer').dataset.productCount;
    const containers = document.querySelectorAll('.product-count');
    let countLabel = count == 1 ? count + '<span> Item</span>' : count + '<span> Items</span>';
    if(containers.length > 0) {
        containers.forEach((container) => {
            container.innerHTML = countLabel;
//             container.classList.remove('loading');            
        })
    }

  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = [/*'.mobile-facets__open', '.mobile-facets__count', */'.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      let elements = document.querySelectorAll(selector)
      elements.forEach((element)=>{
        element.innerHTML = html.querySelector(selector).innerHTML;
      })
    });

//     document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = this.querySelectorAll('form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
  
  facetMobileShow(event) {
      document.querySelector('body').classList.add('show-facets');
  }

  facetMobileCloseMenu(event) {
      document.querySelector('body').classList.remove('show-facets');
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
    
    const rangeSlider1 = this.querySelector('.range-one');
    const rangeSlider2 = this.querySelector('.range-two');
    const rangeMark1 = this.querySelector('.lo');
    const rangeMark2 = this.querySelector('.hi');
    const trackColor = rangeSlider1.dataset.trackColor;
    const trackActiveColor = rangeSlider1.dataset.trackActiveColor;

    const rangeChange = () => {
      var fromValue = parseInt(rangeSlider1.value);
      var toValue = parseInt(rangeSlider2.value);
      rangeMark1.querySelector('span').innerHTML = fromValue;
      rangeMark2.querySelector('span').innerHTML = toValue;
      this.fillSlider(rangeSlider1, rangeSlider2, trackColor, trackActiveColor, rangeSlider2, rangeMark1, rangeMark2);
      if(fromValue > toValue) {
        rangeSlider1.value = toValue;
        rangeSlider2.value = fromValue;
        fromValue = parseInt(rangeSlider1.value);
        toValue = parseInt(rangeSlider2.value);
      }
      this.querySelector('[name="filter.v.price.gte"]').value = fromValue;
      this.querySelector('[name="filter.v.price.lte"]').value = toValue;
    }
    
    rangeSlider1.oninput = () => rangeChange();
    rangeSlider2.oninput = () => rangeChange();
    rangeChange();
  }

  fillSlider(from, to, sliderColor, rangeColor, controlSlider, rangeMark1, rangeMark2) {
      const rangeDistance = to.max-to.min;
      const fromPosition = from.value - to.min;
      const toPosition = to.value - to.min;
      controlSlider.style.background = `linear-gradient(
        to right,
        ${sliderColor} 0%,
        ${sliderColor} ${(fromPosition)/(rangeDistance)*100}%,
        ${rangeColor} ${((fromPosition)/(rangeDistance))*100}%,
        ${rangeColor} ${(toPosition)/(rangeDistance)*100}%, 
        ${sliderColor} ${(toPosition)/(rangeDistance)*100}%, 
        ${sliderColor} 100%)`;
      const m1 = rangeMark1.offsetWidth / 2;
      const m2 = rangeMark2.offsetWidth / 2;
//       rangeMark1.style.left = `calc(${(fromPosition)/(rangeDistance)*100}% - ${m1}px)`;
//       rangeMark2.style.left = `calc(${(toPosition)/(rangeDistance)*100}% - ${m2}px)`;
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);